import React from "react";

const Expired = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        textAlign: "center",
        width: "100%",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <h1>
        Your session expired!! Please <a href="Login">Login</a>
      </h1>
    </div>
  );
};

export default Expired;
